export default {"PACKAGE_VERSION":"0.0.0","GIT_REVISION":"b7eb0da","BUILD_DATE":"2023-10-06T22:44:50.558Z"};